import { useGetClientProfile } from '@/api/clients/get-client-profile'
import { MaintenanceDashboard } from '@/pages/maintenance/maintenance-dashboard'

import * as S from './maintenance.styled'
import { ClientProfileMaintenanceProps } from './maintenance.types'

export const Maintenance = ({ clientId }: ClientProfileMaintenanceProps) => {
  const { data: clientData, isLoading } = useGetClientProfile({ clientId })

  if (isLoading || !clientData) return null

  const resident = {
    apartment: clientData.apartment,
    buildingNumber: clientData.buildingNumber,
    id: Number(clientId),
    name: `${clientData.user.firstName} ${clientData.user.lastName}`,
  }

  return (
    <S.Container>
      <MaintenanceDashboard resident={resident} building={clientData.buildingId} />
    </S.Container>
  )
}
